import React, {useEffect, useState} from 'react';
import {useAuth0} from '@auth0/auth0-react';
import {useLocation, useNavigate} from "react-router-dom";
import {FullLoadingPage, NotAuthenticatedPage} from "../../screens";
import {useDispatch, useSelector} from "react-redux";
import {setIsAuthenticated} from "../../business/redux/reducers/auth/actions";

const AuthWrapper = ({children}) => {
    const { isAuthenticated } = useSelector(s => s.authReducer);
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");

    const hardCodeToken = "6f5gh46d5fh465fdhg654fd6g5h46d5fgh65gfdh6546gfd5h465dgfh465dhg";

    useEffect(() => {
        const isLoggedIn = sessionStorage.getItem("authenticated") === "true";

        if (!isAuthenticated && isLoggedIn) {
            dispatch(setIsAuthenticated(true));
            return;
        }

        if (!isAuthenticated && token === hardCodeToken) {
            sessionStorage.setItem("authenticated", "true");
            dispatch(setIsAuthenticated(true));
        } else if (!isLoggedIn) {
            sessionStorage.setItem("authenticated", "false");
            dispatch(setIsAuthenticated(false));
            navigate('/');
        }
        setLoading(false);
    }, [token, dispatch, navigate, isAuthenticated]);

    if (loading) return <FullLoadingPage/>

    // const {isLoading, error, isAuthenticated, loginWithRedirect} = useAuth0();
    //
    // React.useEffect(() => {
    //     if (!isLoading && !isAuthenticated && !error) {
    //         loginWithRedirect();
    //     }
    // }, [isLoading, isAuthenticated, error, loginWithRedirect]);
    //
    // if (isLoading) {
    //     return <div>Loading authentication...</div>;
    // }
    //
    // if (error) {
    //     return <div>Authentication Error: {error.message}</div>;
    // }

    return isAuthenticated ? <>{children}</> : <NotAuthenticatedPage/>
};

export default AuthWrapper;
